import Vue from 'vue'
import VueI18n from 'vue-i18n'
import viLocale from 'element-ui/src/locale/lang/vi'
import enLocale from 'element-ui/src/locale/lang/en'
import customVi from './lang/vi'
import customEn from './lang/en'

Vue.use(VueI18n)

const resources = {
  resources: {
  }
}

const messages = {
  'vi': Object.assign(
    viLocale,
    customVi,
    resources
  ),
  'en': Object.assign(
    enLocale,
    customEn,
    resources
  )
}

const i18n = new VueI18n({
  locale: 'vi',
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js